module.exports = __webpack_public_path__ + "img/fish-bones.aad17182.svg";